// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"ae1cad04","453":"782296d0","552":"a34fcc49"}[chunkId] + ".chunk.js";
};